module.exports = __webpack_public_path__ + "static/media/varie6c.fefc0d34.jpg";